<template>
  <div class="notification-setting-card" data-testid="notificationSettingCard">
    <div class="notification-setting-card__header">
      <bg-text size="body-2">
        <strong>{{ recipient.name || '-' }}</strong>
        ({{ roleLabel }}) &middot; {{ recipient.phone_number || '-' }}
      </bg-text>

      <bg-text size="body-4" class="notification-setting-card__note">
        Catatan: {{ recipient.note || '-' }}
      </bg-text>
    </div>

    <div class="notification-setting-card__body">
      <div class="notification-setting-card__body-head">
        <bg-text size="title-4">Notifikasi</bg-text>

        <bg-button-icon
          icon="edit"
          size="sm"
          variant="tertiary-naked"
          data-testid="notificationSettingCard-edit"
          @click="$emit('edit', recipient)"
        />
      </div>

      <div v-if="chips.length" class="notification-setting-card__chips">
        <span
          v-for="chip in chips"
          :key="chip.value"
          class="notification-setting-card__chip"
          :class="
            chip.enabled
              ? 'notification-setting-card__chip--active'
              : 'notification-setting-card__chip--inactive'
          "
        >
          <bg-icon :name="chip.enabled ? 'checkmark' : 'close'" size="sm" />
          {{ chip.label }}
        </span>
      </div>

      <bg-text v-else size="body-4" class="notification-setting-card__empty">
        Tidak ada notifikasi.
      </bg-text>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import { BgText, BgIcon, BgButtonIcon } from 'bangul-vue';
import {
  keeperRoleLabel,
  notificationTypeLabel,
} from '@admin/pages/PropertyNotificationSettings/constants';

export default {
  name: 'NotificationSettingCard',

  components: {
    BgText,
    BgIcon,
    BgButtonIcon,
  },

  props: {
    recipient: {
      type: Object,
      required: true,
    },
    types: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const roleLabel = computed(() => keeperRoleLabel(props.recipient.role));

    const chips = computed(() => {
      const enabled = props.recipient.enabled_notification_types || [];

      return props.types.map(type => ({
        value: type.value,
        label: notificationTypeLabel(type.value, type.label),
        enabled: enabled.includes(type.value),
      }));
    });

    return { roleLabel, chips };
  },
};
</script>

<style lang="scss" scoped src="./NotificationSettingCard.scss" />
